let idx = 0;
const uuid = () => (idx += 1);

export default function generateId(name) {
  return `id${name ? `-${name}` : ""}-${uuid()}`;
}
